import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { SharedService } from '../shared.service';
import { EmployerService } from './employer.service';
import { EmployerData } from './employerData';
@Component({
  selector: 'app-employer',
  templateUrl: './employer.component.html',
  styleUrls: ['./employer.component.css']
})
export class EmployerComponent implements OnInit {
  data;

  constructor(private router: Router, private sharedService: SharedService, private empService: EmployerService, private auth: AuthService) { }

  ngOnInit() {
    if (localStorage.getItem('role') != 'employer') {
      if (localStorage.getItem('role') === 'candidate')
        this.router.navigate(['/dashboard'])
      else {
        this.auth.signOut();
        this.router.navigate([''])
      }
    }
    this.auth.getUserId().subscribe(
      (a) => {
        console.log(a);
        this.empService.getEmployerDetails(a.uid).subscribe((b: EmployerData) => {
          console.log(b);
          this.data = b;
          this.sharedService.updatedisplayName(b.profile.first_name)
        })
      })
    this.test();
  }

  test() {
    console.log(this.data)
  }
}
